import React from 'react';

const FACES = ['😊', '😐', '😕', '😢', '😰', '😭'];
const FACE_LABELS = ['NO HURT', 'HURTS LITTLE BIT', 'HURTS LITTLE MORE', 'HURTS EVEN MORE', 'HURTS WHOLE LOT', 'HURTS WORST'];

const PainScale = ({
  label = 'Pain Assessment',
  ratingValue = null,
  faceValue = null,
  onRatingChange = null,
  onFaceChange = null,
}) => {
  const isReadOnly = !onRatingChange && !onFaceChange;

  return (
    <div className="pain-assessment-section">
      <h4>{label}</h4>

      {/* Visual Analogue Scale */}
      <div className="pain-scale">
        <div className="scale-header">
          <h5>Visual Analogue Scale</h5>
          <p>Circle the Number from 0 to 10 That Best Describes Your Pain</p>
        </div>
        <div className="scale-container">
          <div className="scale-line"></div>
          <div className="scale-labels">
            <span>No Pain</span>
            <span>Distressing Pain</span>
            <span>Unbearable Pain</span>
          </div>
          <div className="scale-numbers">
            {[...Array(11)].map((_, num) => (
              <button
                key={num}
                type="button"
                className={`scale-number ${ratingValue === num ? 'selected' : ''}`}
                onClick={!isReadOnly && onRatingChange ? () => onRatingChange(num) : undefined}
                disabled={isReadOnly}
              >
                {num}
              </button>
            ))}
          </div>
        </div>
      </div>

      {/* Faces Scale */}
      <div className="faces-scale">
        <h5>"Faces" Pain Rating Scale</h5>
        <div className="faces-container">
          {FACES.map((face, index) => (
            <div
              key={index}
              className={`face-item ${faceValue === index ? 'selected' : ''}`}
              onClick={!isReadOnly && onFaceChange ? () => onFaceChange(index) : undefined}
              style={{ cursor: isReadOnly ? 'default' : 'pointer' }}
            >
              <div className="face-circle">
                <span className="face-emoji">{face}</span>
              </div>
              <div className="face-label">{FACE_LABELS[index]}</div>
            </div>
          ))}
        </div>
      </div>
    </div>
  );
};

export default PainScale;
